import { Component, inject, OnInit, ViewChild } from '@angular/core';
import { NotificationCenterService } from '../notification-center.service';
import { PhitoNotification } from '../classes/PhitoNotification';
import { CdkConnectedOverlay, CdkOverlayOrigin, ConnectionPositionPair } from '@angular/cdk/overlay';
import { MatTab, MatTabGroup } from '@angular/material/tabs';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatBadge } from '@angular/material/badge';
import { NotificationOverviewListComponent } from '../notification-overview-list/notification-overview-list.component';
import { NotificationSettingsListComponent } from '../notification-settings-list/notification-settings-list.component';
import { MatTooltip } from "@angular/material/tooltip";

@Component({
    selector: 'phito-notification-center-button',
    templateUrl: './notification-center-button.component.html',
    styleUrls: ['./notification-center-button.component.scss'],
    imports: [
    MatIconButton,
    CdkOverlayOrigin,
    MatIcon,
    MatBadge,
    CdkConnectedOverlay,
    MatTabGroup,
    MatTab,
    NotificationOverviewListComponent,
    NotificationSettingsListComponent,
    MatTooltip
],
})
export class NotificationCenterButtonComponent implements OnInit {
    private notificationCenterService = inject(NotificationCenterService);

    notifications: PhitoNotification[] = [];
    unread: number;
    opened: boolean = false;

    positionPairs: ConnectionPositionPair[] = [
        {
            offsetX: 60,
            offsetY: 0,
            originX: 'end',
            originY: 'bottom',
            overlayX: 'end',
            overlayY: 'top',
            panelClass: null,
        },
    ];

    @ViewChild('trigger') trigger: CdkOverlayOrigin;
    @ViewChild('matTabGroup') matTabGroup: MatTabGroup;

    ngOnInit(): void {
        this.loadAllNotifications();

        this.notificationCenterService.watchNotificationPipeline().subscribe((notification) => {
            this.loadAllNotifications();
        });

        this.notificationCenterService.watchCloseNotificationContainer().subscribe({
            next: (close: boolean) => {
                if (close) {
                    this.opened = false;
                    this.notificationCenterService.triggeredNotificationOverlay(false);
                }
            },
        });
    }

    triggerNotificationOverlay(event: MouseEvent) {
        this.opened = !this.opened;
        this.notificationCenterService.triggeredNotificationOverlay(this.opened);
    }

    private loadAllNotifications() {
        this.notificationCenterService.getNotifications().subscribe({
            next: (notifications) => {
                this.notifications = <PhitoNotification[]>notifications?.data;
            },
        });

        this.notificationCenterService.getNotificationsUnread().subscribe({
            next: (notifications) => {
                this.unread = notifications.totalCount;
            }
        });
    }
}
